import React from "react";
import { SupportHeaderContainer } from "./supportElements";

const SupportHeader = ({ heading, subtitle }) => {
  return (
    <SupportHeaderContainer>
      <div className="supportContainer">
        <h2>{heading || "Contact Support"}</h2>
        <p style={{ fontSize: "18px" }}>
          {subtitle ||
            "The world doesn’t stop, and neither do we. How can we help?"}
        </p>
      </div>
    </SupportHeaderContainer>
  );
};

export default SupportHeader;
